import { useState } from 'react';

export function useTenant(setProviderState) {
    const tenantPattern =
        /^[A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12}$/i;
    const [tenants, setTenants] = useState([]);
    const [tenantInput, setTenantInput] = useState('');
    const [tenantError, setTenantError] = useState({
        isError: false,
        message: '',
        duplicates: '',
    });

    //#region Tenants
    const addTenants = (tenantsToAdd) => {
        const newTenants = [...tenants, ...tenantsToAdd];

        setTenants(newTenants);
        setTenantInput('');
    };

    const removeTenant = (tenant) => {
        const index = tenants.findIndex((e) => e === tenant);
        if (index !== -1) {
            const newTenants = [...tenants];
            newTenants.splice(index, 1);
            setTenants(newTenants);
            if (newTenants.length == 0) {
                setProviderState((prevState) => ({
                    ...prevState,
                    isBoth: '0',
                }));
            }
        }
    };

    const handleTenantChange = (e) => {
        setTenantError({ isError: false, message: '', duplicates: '' });
        setTenantInput(e.target.value.trim());
    };

    const handleTenantKeyDown = (e) => {
        if (['Enter', 'Tab', ','].includes(e.key)) {
            setTenantError({ isError: false, message: '', duplicates: '' });
            e.preventDefault();

            // check for duplicates
            if (tenants.includes(tenantInput)) {
                setTenantError((prevState) => ({
                    ...prevState,
                    isError: true,
                    duplicates: `Tenant ID already exists ${tenantInput}.`,
                }));
                return;
            }
            // check for format
            if (!tenantPattern.test(tenantInput)) {
                setTenantError((prevState) => ({
                    ...prevState,
                    isError: true,
                    message: `Invalid Tenant ID ${tenantInput}.`,
                }));
                return;
            }
            // add value to list
            addTenants([tenantInput]);
        }
    };

    const handleTenantPaste = (e) => {
        e.preventDefault();
        setTenantError({ isError: false, message: '', duplicates: '' });

        const pastedData = e.clipboardData.getData('text');
        // remove return and new line, split by comma and filter by empty string if exist
        const pastedTenants = pastedData
            .trim()
            .replace(/\s+/g, '')
            .split(',')
            .filter((uuid) => uuid !== '');

        let invalidIds = [];
        let duplicateIds = [];
        let allowedTenants = [];
        pastedTenants.map((tenant) => {
            // tenant already exist, add to duplicate error message
            if (tenants.includes(tenant)) {
                duplicateIds.push(tenant);
                return;
            }
            // tenant does not match guid format, add to invalid ids error message
            if (!tenantPattern.test(tenant)) {
                invalidIds.push(tenant);
                return;
            }
            allowedTenants.push(tenant);
        });

        addTenants(allowedTenants);

        let duplicateString = '';
        duplicateIds?.map((dup) => {
            // if last index, add it with a fullstop, else comma
            if (duplicateIds.indexOf(dup) === duplicateIds.length - 1) {
                duplicateString += dup + '.';
            } else {
                duplicateString += dup + ', ';
            }
        });
        if (duplicateString) {
            setTenantError((prevState) => ({
                ...prevState,
                isError: true,
                duplicates: 'Tenant ID already exists ' + duplicateString,
            }));
        }

        let invalidString = '';
        invalidIds?.map((inv) => {
            // if last index, add it with a fullstop, else comma
            if (invalidIds.indexOf(inv) === invalidIds.length - 1) {
                invalidString += inv + '.';
            } else {
                invalidString += inv + ', ';
            }
        });

        if (invalidString) {
            setTenantError((prevState) => ({
                ...prevState,
                isError: true,
                message: 'Invalid Tenant ID ' + invalidString,
            }));
        }
    };

    const handleTenantCloseClick = (tenant) => {
        removeTenant(tenant);
    };
    //#endregion

    return {
        tenants,
        setTenants,
        tenantInput,
        tenantError,
        setTenantError,
        addTenants,
        handleTenantChange,
        handleTenantKeyDown,
        handleTenantPaste,
        handleTenantCloseClick,
    };
}
